import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import webRoutes from "./RouteList";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import ScrollToTop from "../components/common/ScrollToTop";
import PageNotFound from "../pages/PageNotFound";

const AppRoutes = () => {
    return (
        <Router>
            <ScrollToTop>
                <Routes>
                    {webRoutes.map((route, index) => (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                route.isPrivate ?
                                    <PrivateRoute element={route.element} />
                                    : <PublicRoute element={route.element} />
                            } />
                    ))}
                    <Route path={"*"} element={<PageNotFound />} />
                </Routes>
            </ScrollToTop>
        </Router>
    );
};
export default AppRoutes;